import styled from '@emotion/styled';
import React from 'react';

import colors from 'config/theme/colors';

const Relative = styled.div`
  position: relative;

  .retweet {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 32px;
  }
`;

const CamerasIcon = styled.div`
  top: 34px;
  left: 34px;
  cursor: pointer;
  position: absolute;
  color: ${colors['@white']};
`;

type CamerasProps = {
  onChange: () => void;
}

const Cameras: React.FC<CamerasProps> = ({ onChange }) => (
  <CamerasIcon onClick={onChange}>
    <Relative>
      <span className="retweet fb-icon--refresh" />
    </Relative>
  </CamerasIcon>
);

export default Cameras;
